"use client";
import React from "react";
import Link from "next/link";
import { MessageCircle, Instagram } from "lucide-react";

export const ServicesSection = () => {
  // Commented out form fields - keeping for reference
  /*
  const formFields = {
    topRow: [
      { id: "firstName", label: "First Name", type: "text" },
      { id: "lastName", label: "Last Name", type: "text" },
    ],
    email: { id: "email", label: "Email", type: "email" },
  };

  const inputClassName =
    "h-14 w-full font-jakarta text-base bg-white placeholder-[#0D0D0D] text-[#0D0D0D] rounded-md border px-4";

  const textareaClassName =
    "h-[212px] w-full resize-none font-jakarta text-base bg-white placeholder-[#0D0D0D] text-[#0D0D0D] rounded-md border px-4 py-3";
  */

  return (
    <div className="w-full max-w-[855px] mx-auto my-8 px-4 sm:px-6 lg:px-0">
      {/* Commented out form - keeping for reference */}
      {/*
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
        {formFields.topRow.map((field) => (
          <div key={field.id}>
            <Input
              id={field.id}
              type={field.type}
              placeholder={field.label}
              className={inputClassName}
            />
          </div>
        ))}
      </div>

      <div className="mb-4">
        <Input
          id={formFields.email.id}
          type={formFields.email.type}
          placeholder={formFields.email.label}
          className={inputClassName}
        />
      </div>

      <div>
        <Textarea
          id="message"
          placeholder="Message"
          className={textareaClassName}
        />
      </div>
      */}

      {/* Social Media Buttons */}
      <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
        {/* WhatsApp Button */}
        <Link
          href="https://wa.me/917982579691"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-3 bg-[#25D366] hover:bg-[#25D366]/90 text-white font-jakarta font-semibold text-lg px-8 py-4 rounded-xl transition-all duration-200 transform hover:scale-105 shadow-lg hover:shadow-xl w-full sm:w-auto justify-center"
        >
          <MessageCircle className="w-6 h-6" />
          Chat on WhatsApp
        </Link>

        {/* Instagram Button */}
        <Link
          href="https://instagram.com/outcomeouting"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-3 bg-gradient-to-r from-[#E4405F] via-[#F56040] to-[#FFDC80] hover:from-[#E4405F]/90 hover:via-[#F56040]/90 hover:to-[#FFDC80]/90 text-white font-jakarta font-semibold text-lg px-8 py-4 rounded-xl transition-all duration-200 transform hover:scale-105 shadow-lg hover:shadow-xl w-full sm:w-auto justify-center"
        >
          <Instagram className="w-6 h-6" />
          Follow on Instagram
        </Link>
      </div>

      {/* Alternative WhatsApp Number */}
      <div className="mt-6 text-center">
        <p className="font-jakarta text-sm text-[#666] mb-2">
          Alternative Contact:
        </p>
        <Link
          href="https://wa.me/919999052908"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 text-[#063258] hover:text-[#25D366]/80 font-jakarta font-medium text-base transition-colors duration-200"
        >
          <MessageCircle className="w-4 h-4" />
          +91 9999052908
        </Link>
      </div>
    </div>
  );
};
